import React from 'react';
import 'antd/dist/antd.css';
import {Button} from 'antd';
import { Link } from 'react-router-dom';
import { Row, Col, } from 'antd';
import { Form, Input  } from 'antd';
import Logo from '../../Images/logo.png';


class NormalLoginForm extends React.Component {
  state = { visible: false };

  showModal = () => {
    this.setState({
      visible: true,
    });
  };

  handleOk = e => {
    
    this.setState({
      visible: false,
    });
    console.log('closed');
  };

  handleCancel = e => {
    
    this.setState({
      visible: false,
    });
    console.log('closed');
  };
  handleSubmit = e => {
    e.preventDefault();
    this.props.form.validateFields((err, values) => {
      if (!err) {
        this.props.history.push('/carrier_app/allOrders');
        console.log('Received values of form: ', values);}});
      };
      render() {
        const { getFieldDecorator } = this.props.form;
        return (
        <div>
          <Form onSubmit={this.handleSubmit} className="login-form">
            <Row>
              <Col span={6}>
                <img src={Logo} className="Logo" alt="Logo" />
              </Col>
              <Col span={16}>
                <h3 className="bulk">Bulk Material PRO </h3>
                <p className="carrier">Carrier Portal</p>
              </Col>
            </Row>
            <Row>
              <h2 className="Login">Login</h2>
              <p className="loginsubtext">We are growing our community daily with lots of customers</p>
            </Row>
            <Form.Item>
              {getFieldDecorator('Email', {
                rules: [{ required: true, message: 'Please input your email!' }],
                })(<Input 
                  placeholder="Email"
                 />,)}
            </Form.Item>
            <Form.Item>
              {getFieldDecorator('password', {
                rules: [{ required: true, message: 'Please input your Password!' }],})(
                <Input
                  
                  type="password" placeholder="Password"/>,)}
            </Form.Item>
            <Form.Item className="password-row">
              {/* <a className="login-form-forgot" href="#">Forgot password?</a> */}
              <span>Forgot password?</span>
              <Button type="primary" htmlType="submit" className="login-form-button">Login</Button>
            </Form.Item>
          </Form>
          <div className="footer">
            <p>Don't have a account? <Link to ="/carrier_login/Signup"  className='Loginclick'>Click Here to Register</Link></p>
          </div>
       </div>
    );
  }
}

const WrappedNormalLoginForm = Form.create({ name: 'normal_login' })(NormalLoginForm);

export default WrappedNormalLoginForm;